module.exports = __webpack_public_path__ + "img/12-5.5f39ead4.png";